import { exists } from '@/api'
import dayjs from 'dayjs'

export interface BatchSchoolStatisticsBestReaderConditionListItem {
  lendDateFrom: string
  lendDateTo: string
  lendType: number[]
  collectionTypeFrom: string
  collectionTypeTo: string
  rdoBunruiType: string
  bunruiFrom: string
  bunruiTo: string
  orderLimit: string
  isStatisticsBranch: boolean
  isStatisticsGrade: boolean
  isStatisticsClass: boolean
  isStatisticsGender: boolean
  isStatisticsAge: boolean
  isStatisticsSearchType: boolean
  isStatisticsMaterialFormat: boolean
  branch: string
  grade: string
  class: string
  gender: string
  age: string
  searchType: string
  materialFormat: string
  batchType: string
  memo: string
}

export function BatchSchoolStatisticsBestReaderConditionListItemFromJSON(
  json: any
): BatchSchoolStatisticsBestReaderConditionListItem {
  const resp = JSON.parse(json)

  return {
    lendDateFrom: exists(resp, 'lend_date_from')
      ? resp.lend_date_from
      : dayjs()
          .add(-1, 'month')
          .format('YYYYMMDD'),
    lendDateTo: exists(resp, 'lend_date_to')
      ? resp.lend_date_to
      : dayjs().format('YYYYMMDD'),
    lendType: exists(resp, 'lend_type') ? resp.lend_type : [0, 0, 0, 0],
    collectionTypeFrom: exists(resp, 'collection_type_from')
      ? resp.collection_type_from
      : '',
    collectionTypeTo: exists(resp, 'collection_type_to')
      ? resp.collection_type_to
      : '',
    rdoBunruiType: exists(resp, 'rdo_bunrui_type') ? resp.rdo_bunrui_type : '1',
    bunruiFrom: exists(resp, 'bunrui_from') ? resp.bunrui_from : '',
    bunruiTo: exists(resp, 'bunrui_to') ? resp.bunrui_to : '',
    orderLimit: exists(resp, 'order_limit') ? resp.order_limit : '',
    isStatisticsBranch: exists(resp, 'is_statistics_branch')
      ? resp.is_statistics_branch
      : false,
    isStatisticsGrade: exists(resp, 'is_statistics_grade')
      ? resp.is_statistics_grade
      : false,
    isStatisticsClass: exists(resp, 'is_statistics_class')
      ? resp.is_statistics_class
      : false,
    isStatisticsGender: exists(resp, 'is_statistics_gender')
      ? resp.is_statistics_gender
      : false,
    isStatisticsAge: exists(resp, 'is_statistics_age')
      ? resp.is_statistics_age
      : false,
    isStatisticsSearchType: exists(resp, 'is_statistics_search_type')
      ? resp.is_statistics_search_type
      : false,
    isStatisticsMaterialFormat: exists(resp, 'is_statistics_material_format')
      ? resp.is_statistics_material_format
      : false,
    branch: exists(resp, 'branch') ? resp.branch : '',
    grade: exists(resp, 'grade') ? resp.grade : '',
    class: exists(resp, 'class') ? resp.class : '',
    gender: exists(resp, 'gender') ? resp.gender : '',
    age: exists(resp, 'age') ? resp.age : '',
    searchType: exists(resp, 'search_type') ? resp.search_type : '',
    materialFormat: exists(resp, 'material_format') ? resp.material_format : '',
    memo: exists(resp, 'memo') ? resp.memo : '',
    batchType: resp.batch_type
  }
}
